import React, { useState } from "react";
import assets from "../../assets/assets";
import Icons from "../../assets/icons";
import Trophy from "../../component/Trophy";
import Understanding from "../../component/Understanding";
import Savingsclient from "../../component/Savingsclient";
import TrustedSlider from "../../component/TrustedSlider";
import Album from "../../component/Album";
import Pyramid from "../../component/Pyramid";

const Home = () => {
  const {
    hero_bg_image,
    demo_it_business_One,
    demo_it_business_two,
    walmart,
    netflix,
    invision,
    yahoo,
    amazon,
  } = assets();

  return (
    <main>
      <section
        className="cover-background full-screen ipad-top-space-margin py-0 md-h-750px sm-h-650px"
        style={{ backgroundImage: `url(${hero_bg_image})` }}
      >
        <div className="opacity-very-light bg-black"></div>
        <div className="shape-image-animation bottom-0 p-0 w-100 d-none d-md-block">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="3000"
            height="400"
            viewBox="0 180 2500 200"
            fill="#ffffff"
          >
            <path
              className="st1"
              d="M 0 250 C 1200 400 1200 50 3000 250 L 3000 550 L 0 550 L 0 250"
            >
              <animate
                attributeName="d"
                dur="5s"
                values="M 0 250 C 1200 400 1200 50 3000 250 L 3000 550 L 0 550 L 0 250;
                            M 0 250 C 400 50 400 400 3000 250 L 3000 550 L 0 550 L 0 250;
                            M 0 250 C 1200 400 1200 50 3000 250 L 3000 550 L 0 550 L 0 250"
                repeatCount="indefinite"
              />
            </path>
          </svg>
        </div>
        <div className="container h-100">
          <div className="row align-items-center h-100">
            <div
              className="col-xl-6 col-lg-8 col-md-10 position-relative z-index-1"
              data-anime='{ "el": "childs", "translateY": [0, 0], "perspective": [1200,1200], "scale": [1.05, 1], "rotateX": [30, 0], "opacity": [0,1], "duration": 800, "delay": 200, "staggervalue": 300, "easing": "easeOutQuad" }'
            >
              <span className="ps-25px pe-25px pt-5px pb-5px mb-25px text-uppercase text-white fs-12 ls-1px fw-600 border-radius-100px bg-gradient-dark-gray-transparent d-flex w-70 sm-w-100">
                <i className="bi bi-megaphone text-white icon-small me-10px"></i>
                Grow your business with us
              </span>
              <h1 className="text-white fw-600 ls-minus-2px mb-25px">
                We craft unique business ideas.
              </h1>
              <div>
                <p className="fw-300 fs-18 w-85 sm-w-95 text-white opacity-6">
                  We're a fully dedicated corporate service agency collaborating
                  with brands all over the world.
                </p>
              </div>
              <a
                href="/services"
                target="blank"
                className="btn btn-extra-large btn-switch-text btn-gradient-purple-pink btn-rounded me-10px ls-0px mt-15px"
              >
                <span>
                  <span className="btn-double-text text-light" data-text="Explore crafto">
                    Explore crafto
                  </span>
                  <span>
                    <i className="text-light fa-brands fa-youtube"></i>
                  </span>
                </span>
              </a>
              <a
                href="/contact"
                className="btn btn-extra-large btn-switch-text btn-transparent-white-light btn-rounded border-1 ls-0px mt-15px"
              >
                <span>
                  <span className="btn-double-text" data-text="Contact us">
                    Contact us
                  </span>
                  <span>
                    <i className="fa-regular fa-envelope"></i>
                  </span>
                </span>
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="my-0">
        <Trophy />
      </section>

      <section className="pt-3 sm-pt-50px">
        <div className="container">

          <div className="row mb-10 align-items-center">
            <div className="col-lg-5 position-relative md-mb-20">
              <div
                class="w-70 xs-w-80"
                data-animation-delay="50"
                data-shadow-animation="true"
              >
                <img
                  alt=""
                  className="border-radius-8px w-100"
                  src={demo_it_business_One}
                // style="display:none;visibility:hidden;"
                />
                <noscript>
                  <img
                    src={demo_it_business_One}
                    alt=""
                    className="border-radius-8px w-100"
                  />
                </noscript>
              </div>
              <div
                className="w-60 overflow-hidden position-absolute right-minus-15px xs-right-15px xs-w-60 bottom-minus-50px"
                data-shadow-animation="true"
                data-animation-delay="250"
                data-bottom-top="transform: translateY(50px)"
                data-top-bottom="transform: translateY(-50px)"
              >
                <img
                  alt=""
                  className="border-radius-8px w-100 box-shadow-quadruple-large"
                  src={demo_it_business_two}
                // style="display:none;visibility:hidden;"
                />
                <noscript>
                  <img
                    src={demo_it_business_two}
                    alt=""
                    className="border-radius-8px w-100 box-shadow-quadruple-large"
                  />
                </noscript>
              </div>
            </div>
            <div
              className="col-xl-5 col-lg-6 offset-lg-1"
              data-anime='{ "el": "childs", "translateY": [30, 0], "opacity": [0,1], "duration": 600, "delay":0, "staggervalue": 300, "easing": "easeOutQuad" }'
            >
              <span className="ps-25px pe-25px mb-20px text-uppercase text-base-color fs-12 lh-40 fw-700 border-radius-100px bg-gradient-very-light-gray-transparent d-inline-flex">
                <i className="bi bi-award fs-16 me-5px"></i>Creative approach
              </span>
              <h3 className="text-dark-gray fs-50 fw-700 ls-minus-2px">
                Powerful agency for corporate business.
              </h3>
              <p className="mb-40px sm-mb-25px">
                We strive to develop real-world web solutions that are ideal for
                small to large projects with bespoke project requirements. We
                create compelling web designs, which are the right-fit for your
                target groups and also deliver optimized.
              </p>
              <div className="progress-bar-style-02">
                <div className="progress mb-15px border-radius-50px fw-700 fs-11 lh-11 text-white bg-white">
                  <div
                    className="progress-bar bg-gradient-flamingo-red-transparent m-0 bg-white"
                    role="progressbar"
                    aria-valuenow="98"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    aria-label="business"
                  >
                    <span className="progress-bar-percent text-flamingo">
                      98%
                    </span>
                  </div>
                  <div className="progress-bar-title text-uppercase">
                    business growth
                  </div>
                </div>

                <div
                  className="progress border-radius-50px fw-700 fs-11 lh-11 text-white bg-white"
                  style={{ width: "85%" }}
                >
                  <div
                    className="progress-bar bg-gradient-base-color-transparent m-0 bg-white"
                    role="progressbar"
                    aria-valuenow="85"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    aria-label="technology"
                  >
                    <span className="progress-bar-percent text-base-color">
                      85%
                    </span>
                  </div>
                  <div className="progress-bar-title text-uppercase">
                    new technology
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="row row-cols-1 mt-5 row-cols-lg-5 row-cols-md-3 row-cols-sm-2 clients-style-06 justify-content-center ps-3 pe-3 xs-mt-40px"
            data-anime='{ "el": "childs", "scale": [0.8,1], "opacity": [0,1], "duration": 600, "delay":0, "staggervalue": 300, "easing": "easeOutQuad" }'
          >
            <div className="col-6 col-md-3 client-box text-center md-mb-40px">
              <a href="#">
                <img src={walmart} alt="" />
              </a>
            </div>

            <div className="col-6 col-md-2 client-box text-center md-mb-40px">
              <a href="#">
                <img src={netflix} alt="" />
              </a>
            </div>

            <div className="col-6 col-md-2 client-box text-center md-mb-40px">
              <a href="#">
                <img src={invision} alt="" />
              </a>
            </div>

            <div className="col-6 col-md-2 client-box text-center sm-mb-40px">
              <a href="#">
                <img src={yahoo} alt="" />
              </a>
            </div>

            <div className="col-6 col-md-2 client-box text-center">
              <a href="#">
                <img src={amazon} alt="" />
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="mb-0 py-0">
        <Understanding />
      </section>
      <section className="my-0 py-0">
        <Savingsclient />
      </section>

      <section className="my-0 py-0">
        <Album />
      </section>

      <section className="my-0 py-0">
        <TrustedSlider />
      </section>

      <section className="my-0 py-0">
        <Pyramid/>
      </section>
    </main>
  );
};

export default Home;
